// extracted by mini-css-extract-plugin
module.exports = {"row":"styles_row__2zOh_","column":"styles_column__32LlU","titleWrap":"styles_titleWrap___8wys","title":"styles_title__2_bVp"};